import { render, staticRenderFns } from "./AllMute.vue?vue&type=template&id=03879486&scoped=true&"
import script from "./AllMute.vue?vue&type=script&lang=js&"
export * from "./AllMute.vue?vue&type=script&lang=js&"
import style0 from "./AllMute.vue?vue&type=style&index=0&id=03879486&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03879486",
  null
  
)

export default component.exports